import { createStore } from 'vuex';
import login from './modules/login';
import accordionState from './modules/accordion';
import basket from './modules/basket';
import loading from './modules/loading';
import permissions from './modules/permissions';
import driver from './modules/driver';
import educationBlocks from './modules/educationBlocks';
import moduleConfig from './modules/moduleConfig';
import guide from './modules/guide';
import featureFlags from './modules/featureFlags';
import socket from './modules/socket';
import goods from './modules/goods';
import catalog from './modules/catalog';
import employeeAnalytics from './modules/employeeAnalytics';
import hallsTables from './modules/hallsTables';
import loyaltyStatus from './modules/loyaltyStatus';
import merchantCurrency from './modules/merchantCurrency';
import personal from './modules/personal';
import proposalBuilder from './modules/proposalBuilder';
import { getAppModuleRegistry } from '@/modules';
// import schedule from "./modules/schedule";

const debug = process.env.NODE_ENV !== 'production';
const appModuleRegistry = getAppModuleRegistry();

export default createStore({
  modules: {
    login,
    accordionState,
    basket,
    loading,
    permissions,
    driver,
    educationBlocks,
    moduleConfig,
    guide,
    featureFlags,
    socket,
    goods,
    catalog,
    employeeAnalytics,
    hallsTables,
    loyaltyStatus,
    merchantCurrency,
    personal,
    proposalBuilder,
    ...appModuleRegistry.storeModules,
    // schedule,
  },
  plugins: [],
  strict: debug,
});
